import {SystemTypeViewModel} from "@generatedmodels/SystemTypeViewModel";
import {DisciplineViewModel} from "@generatedmodels/DisciplineViewModel";
import {UnitTypeViewModel} from "@generatedmodels/UnitTypeViewModel";
import { SubElementTypeViewModel } from '@generatedmodels/SubElementTypeViewModel';

export interface IUnitDefinitionModel {
  copyFrom: boolean;
  systemType: SystemTypeViewModel;
  unitType: UnitTypeViewModel;
  discipline: DisciplineViewModel;
  unitTypeCustomDefinition: string;
  copiedUnitType?: number;
  subElementTypes: SubElementTypeViewModel[];
  copySchematicsWithCommissioningSheet: boolean;
}

export class AddNewUnitModel implements IUnitDefinitionModel {
  copyFrom: boolean;
  systemType: SystemTypeViewModel;
  unitType: UnitTypeViewModel;
  discipline: DisciplineViewModel;
  unitTypeCustomDefinition: string;
  copiedUnitType: number;
  subElementTypes: SubElementTypeViewModel[];
  copySchematicsWithCommissioningSheet: boolean;

  constructor() {
    this.discipline = new DisciplineViewModel();
    this.systemType = new SystemTypeViewModel();
    this.unitType = new UnitTypeViewModel();
    this.subElementTypes = [];
    this.copySchematicsWithCommissioningSheet = false;
  }
}
